import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import heroBusinesswoman from "../../assets/right.svg";
import { heroKeywords } from "../../data/homeContent";

export const HeroSection = () => {
    const navigate = useNavigate();
    const [keywordIndex, setKeywordIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setAnimating(true);
            setTimeout(() => {
                setKeywordIndex((prev) => (prev + 1) % heroKeywords.length);
                setAnimating(false);
            }, 280);
        }, 3200);
        return () => clearInterval(interval);
    }, []);

    return (
        <section className="home-section home-hero" id="hero">
            <div className="home-container home-hero__grid">
                <div className="home-hero__content home-animate-in">
                    <p className="home-eyebrow">Honesti Digital</p>
                    <h1 className="home-hero__title">
                        We help you{" "}
                        <span className={`home-hero__keyword ${animating ? "home-hero__keyword--out" : ""}`}>
                            {heroKeywords[keywordIndex]}
                        </span>
                        <br />
                        your business digitally
                    </h1>
                    <p className="home-hero__subtitle">
                        Premium digital solutions and automation software for businesses ready to grow — built in Chennai, trusted nationwide.
                    </p>
                    <div className="home-hero__actions">
                        <Button className="home-btn home-btn--primary" onClick={() => navigate("/contact")}>
                            Book a Consultation <ArrowRightOutlined />
                        </Button>
                    </div>
                </div>
                <div className="home-hero__visual home-animate-in home-animate-in--delay">
                    <div className="home-hero__glow" />
                    <img
                        alt="Businesswoman showcasing digital growth solutions"
                        src={heroBusinesswoman}
                        className="home-hero__visual-image"
                    />
                </div>
            </div>
        </section>
    );
};
